import { render, staticRenderFns } from "./ReenviarFactura.vue?vue&type=template&id=11437644"
import script from "./ReenviarFactura.vue?vue&type=script&lang=js"
export * from "./ReenviarFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports